import { AgGrid } from "@jsq/ds/core";
import { globalEnv } from "~/global-env";
import { toDbId } from "~/utils/graphql-helpers";
import { ExternalLinkCountCellRenderer } from "../../CompliancePositionsTable/ExternalLinkCountCellRenderer";
import { ProfileRowItem } from "../types";

type PositionCellRendererProps = AgGrid.ICellRendererParams<ProfileRowItem>;

export const PositionCellRenderer = ({ data }: PositionCellRendererProps) => {
  const globalPositionIds = data?.positions ?? [];
  const positionIds = globalPositionIds.map((globalId) => toDbId(globalId));

  const positionCount = positionIds?.length;

  const arenaIds = data?.clients ?? [];

  const canNavigate = positionCount > 0 && arenaIds.length > 0;
  const launchLink = `${globalEnv.complianceRoute}/positions?arenaIds=${arenaIds.join(",")}&positionIds=${positionIds.join(",")}`;

  return (
    <ExternalLinkCountCellRenderer
      count={canNavigate ? positionCount : 0}
      launchLink={launchLink}
      tooltipContent="View positions"
      tooltipId="view-positions-tooltip"
      testIdPrefix="view-positions"
    />
  );
};
